import React from 'react'
import { AllowedAccess } from 'react-permission-role'
import { useLocation, useParams } from 'react-router-dom'
import { Card, CardContent, Button, Grid } from '@mui/material';

import { useFetchInitTransactionCashier } from './hooks'
import { ModalModule } from  './ModalModule'
import { TableTransactionCashier } from './TableTransactionCashier'
import { FormTransactionCashier } from './FormTransactionCashier'
import { FilterForm } from './FilterForm'

export const TransactionCashier = () => {

    const location = useLocation();
    const paramsURL = useParams();
    const useFetchInit = useFetchInitTransactionCashier({location, paramsURL})

    const {
        //------------- Generales
        //------------- globalStates
        globalStates,
        //------------- Helpers
        // Helpers,
        //------------- Formularios
        // Forms,
        //------------- FetchData
        // FetchData,
        //------------- Actions
        Actions
    } = useFetchInit

    // ------------------------------------------------ Generales
    // ------------------------------------------------ globalStates
    const { showForm } = globalStates
    // ------------------------------------------------ Helpers
    // ------------------------------------------------ Formularios
    // ------------------------------------------------ FetchData
    // ------------------------------------------------ Actions
    const { handleClickOpenEditableForm } = Actions

    return (
        <AllowedAccess permissions={['165_MOVIMIENTO_DE_CAJAS']} renderAuthFailed={<p>Error</p>}>
            <ModalModule useFetchInit={useFetchInit}/>
            <div className="content">
                {(!showForm) && (
                    <div className="panel-body">
                        <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                <Card style={{zIndex:'1'}}>
                                    <CardContent>
                                        
                                        <div className='h4 mt-1 mb-1'> Cajas: Transacciones </div>
                                        <div className="border-bottom border-dark"></div>
                                        {/* {loadingFetchAllClients && ( <LinearLoading /> )} */}

                                        <div className="d-flex justify-content-end pt-4">
                                            <Button
                                                style={{background: "#4b4b4c"}}
                                                variant="contained"
                                                type="button"
                                                onClick={() => handleClickOpenEditableForm(true, 'EDITABLE')}
                                            >
                                                <i className="fa-solid fa-plus"></i> &nbsp; Agregar
                                            </Button>
                                        </div>

                                        <div className="pt-4"></div>
                                        <FilterForm useFetchInit={useFetchInit} />
                                        <div className="pt-4"></div>
                                        <TableTransactionCashier useFetchInit={useFetchInit} />
                                    </CardContent>
                                </Card>
                            </Grid>
                        </Grid>
                    </div>
                )}
                {(showForm) && (
                    <FormTransactionCashier useFetchInit={useFetchInit} />
                )}
            </div>
        </AllowedAccess>
    )
}
